import { useTranslation } from 'react-i18next';
import React from 'react';
void React;

export default function RBHLoginSection() {
  const { t } = useTranslation();
  return (
    <section className="kr-section kr-rbh-login" aria-labelledby="rbh-login-heading">
      <div className="kr-shell">
        <div className="kr-hero-card" role="region">
          <div className="kr-hero-card-body">
            <h2 id="rbh-login-heading" className="k-h2">{t('homepageUi.text4')}</h2>
            <p className="k-body">{t('homepageUi.text5')}</p>
          </div>
          <div className="kr-hero-card-actions">
            <a className="kr-btn kr-btn-brandbook" href="/login">{t('homepageUi.text3')}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
